import { AdsHandlerActionTypes } from './adsHandler.types';

export const initialState = {
  pages: {
    list: [],
    loading: false,
    error: null,
    status: null,
  },
  drafts: {
    data: null,
    loading: false,
    error: null,
    status: null,
  },
};

const adsHandlerReducer = (state = initialState, action) => {
  switch (action.type) {
    case AdsHandlerActionTypes.ADS_HANDLER_PAGES_REQUEST: {
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: true,
          error: null,
          status: 'loading',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_PAGES_SUCCESS: {
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: false,
          list: action.payload.pages || [],
          error: null,
          status: 'success',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_PAGES_FAILURE: {
      return {
        ...state,
        pages: {
          ...state.pages,
          loading: false,
          error: 'Failed to fetch ads pages',
          status: 'failure',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_REQUEST: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: true,
          error: null,
          status: 'loading',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_SUCCESS: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: false,
          data: action.payload,
          error: null,
          status: 'success',
        },
      };
    }
    case AdsHandlerActionTypes.ADS_HANDLER_DRAFTS_FAILURE: {
      return {
        ...state,
        drafts: {
          ...state.drafts,
          loading: false,
          error: 'Failed to fetch drafts',
          status: 'failure',
        },
      };
    }
    default:
      return state;
  }
};

export default adsHandlerReducer;
